// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ErrorsComponent } from './errors.component';
import { ErrorsRoutingModule } from '@coa/app/errors/errors-routing.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    PageNotFoundComponent,
    ErrorsComponent,
  ],
  imports: [
    CommonModule,
    ErrorsRoutingModule,
    TranslateModule.forChild(),
  ],
})
export class ErrorsModule {
}
